<template>
  <!--    <transition name="fade" mode="out-in">-->
<!--  <keep-alive>-->
    <router-view/>
<!--  </keep-alive>-->
  <!--    </transition>-->
</template>
<script>
  export default {
    name: 'PageIndex'
  }
</script>

<style type="text/scss" lang="scss" scoped>
</style>
